export default "__VITE_ASSET__Cjapl8$M__"